<template>
  <div id="DefaultDialog">
    <el-dialog
      v-if="show"
      class="sQDialog"
      :visible.sync="show"
      :show="show"
      :show-close="false"
      :close-on-press-escape="false"
      :title="title"
      :close-on-click-modal="closeOnClickModal"
      append-to-body>
      <span style="white-space: pre-wrap;word-break: break-word;">{{ text }}</span>
      <img class="img" v-if="img" :src="img" alt="" srcset="">
      <span slot="footer" class="dialog-footer">
        <div class="cancelBtn cursor" @click="yesBtn">{{yesTxt}}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 1000
    },
    hasCloseIcon: { type: Boolean, default: true },
    top: {
      type: [String, Number],
      default: '100px'
    },
    // show: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: false }
    // type: {
    //   type: Number, default: 1
    // }
  },
  name: 'DefaultDialog',
  data () {
    return {
      show: false,
      title: '',
      img: '',
      text: '',
      yesTxt: '确定',
      confirm: null
    }
  },
  methods: {
    noBtn () {
      this.cancel && this.cancel()
      this.show = false
    },
    yesBtn () {
      this.confirm && this.confirm()
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
$width: 100vw/1920;
/deep/ .el-dialog{
  border-radius: 8*$width;
  width: 730*$width;
}
/deep/ .el-dialog__header{
  padding-left: 40*$width;
  border-bottom: 1*$width solid #D8D8D8;
}
/deep/ .el-dialog__title{
  font-size: 20*$width;
  color: #030A17;
  letter-spacing: 0;
  font-weight: bold;
}
/deep/ .img{
  margin-top: 11*$width;
  width: 558*$width;
  height: 496*$width;
  padding-left: 37*$width;
}
/deep/ .el-dialog__body{
  padding-left: 40*$width;
  padding-right:48*$width;
  font-size: 16*$width;
  color: #030A17;
  letter-spacing: 0;
  word-break: break-word;
}
/deep/ .dialog-footer{
  text-align: center;
}
/deep/ .cancelBtn{
  margin: auto;
  font-size: 16*$width;
  color: #FFFFFF;
  letter-spacing: 0;
  background: #296BFF;
  border-radius: 4*$width;
  width: fit-content;
  padding: 9*$width 32*$width;
}
</style>



// WEBPACK FOOTER //
// src/plugin/defaultDialog/src/main.vue